import React from 'react';

import CustomAccordion from 'components/CustomAccordion';
import { ContainerConstants } from 'lib/Constants';

import FAQSectionStyles from './_FAQSectionStyles.module.scss';

const FAQSection = (): JSX.Element => {
    const {
        homePage: {
            faqContainerId,
            faqCopy,
        },
    } = ContainerConstants;

    const massagedFaqCopy = faqCopy.map(copy => {
        if (copy.header === 'How do I participate?') {
            return {
                header: copy.header,
                body: (
                    <p className={FAQSectionStyles['faq-body']}>
                        STEP 1: Purchase any Biofinity ® or MyDay® range of contact lenses products in a single receipt.
                        <br />
                        <br />

                        STEP 2: Visit
                        {' '}
                        <a
                            href='https://www.coopervisionSG-rewards.com'
                            target='_blank'
                            rel='noreferrer'
                        >
                            www.coopervisionSG-rewards.com
                        </a>
                        {' '}
                        and login or sign up, then submit a clear receipt photo.

                        <br />
                        <br />

                        STEP 3: Redeem your GrabGifts e-voucher.
                    </p>
                ),
            };
        }

        if (copy.header === 'How can I redeem my GrabGifts Voucher?') {
            return {
                header: copy.header,
                body: (
                    <p className={FAQSectionStyles['faq-body']}>
                        To redeem your voucher, ensure that you have the latest version of the Grab App installed on your phone, as it cannot be redeemed via a computer or website.

                        <br />
                        <br />

                        Upon a successful submission in www.coopervisionSG-rewards.com, You will receive an acknowledgement email which will show your application status.

                        <br />
                        <br />

                        To redeem your GrabGifts e-voucher:

                        <br />
                        <br />

                        1. Once you&apos;ve received an email notification (which shows as &quot;approved&quot; status), click on the &quot;Visit our website&quot; button, which will direct you to
                        {' '}
                        <a
                            href='https://www.coopervisionSG-rewards.com'
                            target='_blank'
                            rel='noreferrer'
                        >
                            www.coopervisionSG-rewards.com
                        </a>
                        .

                        <br />

                        2. Tap the 3 dots icon at the top right corner &gt; Your Account &gt; Voucher &gt; Collections, which will direct you to the Vouchers collections page.

                        <br />

                        3. Click on the Voucher &gt; Read T&C &gt; Tap the &quot;Redeem Now&quot; Button.

                        <br />

                        4. Copy the GrabGifts Voucher URL to claim it in the Grab App, which will redirect you to the Grab App.(* only click the &quot;Redeem Complete&quot; button after you&apos;ve successfully redeemed your voucher in Grab App).

                        <br />

                        5. A pop-up message will appear with the message,
                        <span>&quot;Thank you! Here&apos;s your $65.00 / $60.00 / $30.00 e-voucher.&quot;</span>

                        <br />

                        <span>6. Tap the &quot;Redeem Your Gift&quot; button, and the $65 / $60 / $30 will be automatically credited to your Grab account.</span>
                        <br />
                        <br />

                        <span>The system will detect the first use of the $65 /$60 /$30 GrabGifts </span>
                        e-voucher. When you select a category such as Transport, Food, or Mart, the voucher will only be applicable within the selected category.

                        <br />
                        <br />

                        The GrabGifts e-voucher can be used multiple times until the balance is depleted or it expires. Only the total transaction amount will be deducted from the GrabGift e-voucher, and you cannot choose the specific value to be deducted.

                        <br />
                        <br />

                        If the balance is below the transaction amount, the GrabGifts e-voucher can be used and the remaining balance can be paid via other payment methods.
                    </p>
                ),
            };
        }

        return copy;
    });

    return (
        <div
            id={faqContainerId}
            className={FAQSectionStyles.container}
        >
            <h2>
                FAQ
            </h2>

            <CustomAccordion
                data={massagedFaqCopy}
            />
        </div>
    );
};

export default FAQSection;
